<template>
  <section id="clients">
    <div v-if="adding_new_client" id="add-client-container">
      <div class="form-field">
        <label for="name">Namn</label>
        <input type="text" name="name" v-model="new_client.name">
      </div>
      <div class="form-field">
        <label for="email">E-post</label>
        <input type="text" name="email" v-model="new_client.email">
      </div>
      <!-- <label for="sms">Nummer för SMS</label> -->
      <!-- <input type="text" name="sms" v-model="new_client.sms"> -->
      <div class="form-field">
        <button class="primary" @click="addClient()">Lägg till</button>
      </div>
    </div>
    <button class="primary add-new-client" @click="adding_new_client = !adding_new_client">
      <span class="text-success" v-if="!adding_new_client">Lägg till ny användare</span>
      <span class="text-warning" v-if="adding_new_client">Stäng</span>
    </button>
    
    <ul class="client-list">
        <li v-for="client in clients">
          <h3>
            {{ client.name }}
            <span class="email" v-if="client.email != ''">{{ client.email }}</span>
          </h3> 
          <div class="client-info">
            <div class="container">
              <p v-if="client.sms != ''">{{ client.sms }}</p>
              <p>App-adress för {{ client.name }} <input v-bind:value="app_url + '?token=' + client.api_token"></p>
            </div>
            <div class="container"> 
              <div class="qr-code" v-if="client.display_qr == true" @click="e => e.target.parentNode.classList.toggle('active')">
                <qr-code 
                v-bind:text="app_url + '?token=' + client.api_token"
                v-bind:size="800"
                ></qr-code>
                <p>Scanna QR-koden för att logga in. Klicka för att förstora.</p>
              </div>
            </div>
          </div>
          <div class="controls">
            <button @click="sendLoginLink(client)">Skicka länk via E-post</button>
            <button v-if="client.display_qr != true" @click="$set(client, 'display_qr', true)">Skapa QR-kod</button>
            <button @click="deleteClient(client)">Ta bort användare</button>
          </div>
        </li>
    </ul>

  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Clients',
  props: {},
  data: function(){
    return {
      adding_new_client: false,
      clients: {},
      new_client: {
        name: '',
        email: '',
        sms: ''
      },
      api_url: this.$parent.api_url,
      app_url: this.$parent.app_url
    }
  },
  mounted: function(){
    let self = this;
    
    if( self.$parent.user.token !== '' ){
      self.loadClients();
    }
  },
  methods: {
    addClient() {
      let self = this;
      let url = self.api_url + "/client";
        
      axios
        .post(
          url,
          {
            name: self.new_client.name,
            email: self.new_client.email,
            sms: self.new_client.sms
          },
          {
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json",
              "Authorization": "Bearer " + self.$parent.user.token
            }
          }
        )
        .then(function(response){
          console.log(response);
          self.loadClients();
          self.new_client.name = '';
          self.new_client.email = '';
          self.new_client.sms = '';
          
        })
        .catch(function(error){
          console.log(error);
          console.log("Something went wrong while adding a new client");
        });
    },
    deleteClient(client){
      let self = this;
      let url = self.api_url + "/clients/" + client.id;

      if( confirm('Vill du ta bort '+ client.name +'?' ) ){
        axios
          .delete(
            url,
            {
              headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + self.$parent.user.token
              }
            }
          )
          .then(function(response){
            console.log(response)
            self.loadClients();
          })
          .catch(function(error){
            console.log(error);
            console.log("Something went wrong while deleting the client")
          });
      }
    },
    loadClients() {
      let self = this;
      axios
        .get(self.api_url + "/clients", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + self.$parent.user.token
          }
        })
        .then(function(response) {
          console.log(response);
          self.clients = response.data;
        })
        .catch(function(error) {
          console.log(error);
          console.log("Something went wrong while loading clients");
        });
    },
    sendLoginLink(client) {
      let self = this;
      let url = self.api_url + "/client/email";
        
      axios
        .post(
          url,
          {
            token: client.api_token
          },
          {
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json",
              "Authorization": "Bearer " + self.$parent.user.token
            }
          }
        )
        .then(function(response){
          console.log(response);
        })
        .catch(function(error){
          console.log(error);
          console.log("Something went wrong while sending email");
        });
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/css/_mixins.scss";
  @import "../assets/css/_variables.scss";
  @import '../assets/css/clients.scss';
</style>
